module.exports = __webpack_public_path__ + "static/media/eric-ries-signature.ea3780b4.svg";